import type { NextApiRequest, NextApiResponse } from 'next'
import type { UpdateOrderPayload, UpdateOrderResponse } from 'ecosystem'
import { briqpayApi } from 'api'

export const briqpayPaymentProvider = async (
  req: NextApiRequest,
  res: NextApiResponse<UpdateOrderResponse | { error: string }>
) => {
  const { briqpayPayload }: UpdateOrderPayload = JSON.parse(req.body)

  if (!briqpayPayload) {
    res.status(400).json({ error: 'Wrong payload' })
    return
  }

  const { sessionId, ...updatedSession } = briqpayPayload

  // Party data (`billing`, `shipping`, `company`) is rejected while the matching module
  // is loaded in the client, and the rejection fails the whole payload — so callers send
  // cart updates and address updates as separate requests.
  const { error, data } = await briqpayApi.checkout.updateSession(sessionId, updatedSession)

  if (error) {
    res.status(400).json({ error: error || 'Unknown error' })
    return
  }

  res.status(200).json({ briqpayResponse: data } as UpdateOrderResponse)
}
